import { type Ref } from 'vue'

import { useReactiveFeatureFlag } from '@/utils/useFeatureFlags'

export const CUSTOM_CAMPAIGNS_ME2_EDITS_FLAG = 'hermes.customCampaignsMe2Edits'

/**
 * Reactive Unleash flag gating the custom-campaign dual-write EDIT path.
 *
 * When enabled, a dashboard edit to a one-time campaign (subject / content /
 * audience) fires one convergent full-state push to ME2 after `publishChanges`
 * resolves, so an ME2-dispatched campaign's send stays in sync with the edit.
 * When disabled, editing behaves exactly as today (Hermes → Olympus/ME1 only);
 * ME2 is never notified, so the Hermes deploy can ship ahead of the Olympus
 * passthrough endpoint.
 *
 * Distinct from {@link useCustomCampaignsMe2Flag} (`hermes.customCampaignsMe2`),
 * which gates the initial SCHEDULE/dispatch handoff — this gates post-schedule
 * EDITS only and must be able to flip independently.
 */
export const useCustomCampaignsMe2EditsFlag = (): Ref<boolean> =>
  useReactiveFeatureFlag(CUSTOM_CAMPAIGNS_ME2_EDITS_FLAG).enabled
